import * as opts from './filterOptions';
import * as filterTypes from './CustomFilterTypes';

export const mapSorter = (sortColumn, sortOrder) => {
  let sort;
  if (sortColumn && sortOrder && sortOrder !== 'NONE') {
    sort = [
      {
        property: sortColumn,
        direction: sortOrder,
      },
    ];
    return encodeURIComponent(JSON.stringify(sort));
  }
  return null;
};

const _getCustomFilterOperation = (subType) => {
  switch (subType) {
    case opts.EQUAL:
      return 'eq';
    case opts.NOT_EQUAL:
      return 'neq';
    case opts.GREATER_THAN:
      return 'gt';
    case opts.LESS_THAN:
      return 'lt';
    case opts.GREATER_THAN_OR_EQUAL_TO:
      return 'gtoe';
    case opts.LESS_THAN_OR_EQUAL_TO:
      return 'ltoe';
    default:
      break;
  }
};

const _getNumberFilterOperator = (filterType) => {
  switch (filterType) {
    case 1:
      return 'eq';
    case 3:
      return 'gt';
    case 4:
      return 'lt';
    default:
      return 'eq';
  }
};

const _mapCustomFilter = (filter) => {
  if (filter.type === filterTypes.NUMERIC_FILTER || filter.type === filterTypes.DATE_FILTER) {
    if (typeof filter.value === 'undefined')
      return [
        {
          property: filter.column.key,
          action: 'REMOVE_FILTER',
        },
      ];
    const filterQueryParam = [
      {
        operator: _getCustomFilterOperation(filter.condition),
        value: filter.value,
        property: filter.column.key,
      },
    ];

    if (filter.type === filterTypes.DATE_FILTER && filterQueryParam.length === 1 && filterQueryParam[0].value) {
      const start = new Date(filterQueryParam[0].value.getTime());

      return [
        {
          operator: _getCustomFilterOperation(filter.condition),
          value: start.toLocaleDateString(),
          property: filter.column.key,
        },
      ];
    }

    // if(filter.type === filterTypes.DATE_FILTER && filterQueryParam.length === 1
    // && filterQueryParam[0].operator === 'neq' && filterQueryParam[0].value){
    // const start = new Date(filterQueryParam[0].value.getTime());
    // start.setHours(0,0,0,0);     var end =  new
    // Date(filterQueryParam[0].value.getTime());     end.setHours(23,59,59,999);
    // return  [         {             operator:
    // _getCustomFilterOperation(opts.LESS_THAN),             value: start,
    // property: filter.column.key         },         {             operator:
    // _getCustomFilterOperation(opts.GREATER_THAN),             value: end,
    // property: filter.column.key         }]; } encodeURIComponent(JSON.stringify(
    return filterQueryParam;
  }
};

const noNeedMapping = (filter) => {
  var keys = Object.keys(filter);
  if (keys.indexOf('property') !== -1 && keys.indexOf('value') !== -1 && keys.indexOf('operator') !== -1) return true;
  else return false;
};

export const mapFilter = (filter) => {
  if (noNeedMapping(filter)) {
    return [filter]; //filter is ready no need any mapping
  }
  if (Array.isArray(filter)) {
    if (filter.every(noNeedMapping)) return filter;
  }

  if (filter.customFilterUid === filterTypes.CUSTOM_FILTER_GUID) {
    const customFilterObj = _mapCustomFilter(filter);

    return customFilterObj;
  } else if (Array.isArray(filter.filterTerm) && filter.filterTerm.length > 0 && filter.filterTerm[0].type) {
    return _mapDefaultNumericFilter(filter);
  } else {
    if (filter.filterTerm) {
      if (Array.isArray(filter.filterTerm)) {
        return _mapAutoCompleteFilter(filter);
      }

      const filterOperator = filter.column.filterOperator ? filter.column.filterOperator : 'eq';

      return [
        {
          operator: filterOperator,
          value: filter.filterTerm.value ? filter.filterTerm.value : filter.filterTerm,
          property: filter.column.key,
        },
      ];
      //return encodeURIComponent(JSON.stringify(result));
    } else {
      return [
        {
          property: filter.column.key,
          action: 'REMOVE_FILTER',
        },
      ];
    }
  }
};

function _mapAutoCompleteFilter(filter) {
  const filterMapped = [
    {
      operator: 'in',
      value: filter.filterTerm.map((f) => f.value),
      property: filter.column.key,
    },
  ];
  if (filter.filterTerm.length === 0) {
    filterMapped[0].action = 'REMOVE_FILTER';
  }
  return filterMapped;
}

function _mapDefaultNumericFilter(filter) {
  let mappedFilter = filter.filterTerm.reduce((result, current) => {
    if (current.type !== 2 && typeof current.value !== 'undefined' && current.value !== null && !isNaN(current.value)) {
      result.push({
        operator: _getNumberFilterOperator(current.type),
        value: current.value,
        property: filter.column.key,
      });
    } else if (current.begin && current.end) {
      result.push({
        operator: 'gt',
        value: current.begin,
        property: filter.column.key,
      });
      result.push({
        operator: 'lt',
        value: current.end,
        property: filter.column.key,
      });
    }
    return result;
  }, []);
  var equalOps = mappedFilter.filter((f) => f.operator === 'eq');
  if (equalOps.length > 1) {
    mappedFilter.push({
      operator: 'in',
      value: equalOps.map((o) => o.value),
      property: filter.column.key,
    });
    mappedFilter = mappedFilter.filter((f) => f.operator !== 'eq');
  }
  //console.table(mappedFilter);
  return mappedFilter;
}
